/**
 * Barra da página do setor: por o quê ver (ambientes, lotes, tarefas, peças),
 * como ver (kanban, mapa, tabela, calendário, linha do tempo), busca livre, o
 * botão de filtros e o sinal de "ao vivo" (a última leitura do estado do app).
 */
import React from "react";
import { FiCalendar, FiClock, FiColumns, FiList, FiMap, FiSearch } from "react-icons/fi";

import PainelFiltros from "./PainelFiltros";
import { ENTIDADES, VISOES } from "./preferencias";
import { AoVivo, Barra, CampoBusca, Espaco } from "./styles";
import { SeletorSegmentado } from "./ui";

const ICONES_VISAO = {
  kanban: FiColumns,
  mapa: FiMap,
  tabela: FiList,
  calendario: FiCalendar,
  timeline: FiClock,
};

const dois = (n) => String(n).padStart(2, "0");

function horaDe(iso) {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? `${dois(d.getHours())}:${dois(d.getMinutes())}` : "";
}

function textoAoVivo({ erro, carregando, atualizadoEm }) {
  if (erro) return `Sem atualizar desde ${horaDe(atualizadoEm) || "a abertura"}`;
  if (carregando) return "Conectando…";
  return `Ao vivo · ${horaDe(atualizadoEm)}`;
}

/**
 * Props: entidade, visao, contagens ({ambiente, lote, tarefa, peca}),
 * onEntidade, onVisao, filtros, definirFiltro, onLimparFiltros,
 * contextoFiltros, resultadoFiltros, estadoMapa ({erro, carregando,
 * atualizadoEm}).
 */
export default function BarraDoSetor({
  entidade,
  visao,
  contagens,
  onEntidade,
  onVisao,
  filtros,
  definirFiltro,
  onLimparFiltros,
  contextoFiltros,
  resultadoFiltros,
  estadoMapa,
}) {
  return (
    <Barra>
      {/* A visão Mapa mostra a SALA (subsetores e postos), não uma lista: o
          "ver por" não muda nada nela, então sai de cena. */}
      {visao !== "mapa" && (
        <SeletorSegmentado
          rotulo="Ver por"
          opcoes={ENTIDADES.map((e) => ({ ...e, n: contagens[e.valor] }))}
          valor={entidade}
          onChange={onEntidade}
        />
      )}
      <SeletorSegmentado
        rotulo="Visualização"
        opcoes={VISOES.map((v) => ({ ...v, icone: ICONES_VISAO[v.valor] }))}
        valor={visao}
        onChange={onVisao}
        compacto
      />
      <CampoBusca>
        <FiSearch size={14} aria-hidden="true" />
        <input
          type="search"
          value={filtros.busca}
          onChange={(e) => definirFiltro("busca", e.target.value)}
          placeholder="Buscar cliente, pedido, ambiente, peça, pessoa ou tarefa"
          aria-label="Buscar no setor"
        />
      </CampoBusca>
      <PainelFiltros
        filtros={filtros}
        definirFiltro={definirFiltro}
        onLimpar={onLimparFiltros}
        contexto={contextoFiltros}
        resultado={resultadoFiltros}
      />
      <Espaco />
      <AoVivo $erro={Boolean(estadoMapa.erro)} title={estadoMapa.erro || undefined}>
        <span className="ponto" aria-hidden="true" />
        {textoAoVivo(estadoMapa)}
      </AoVivo>
    </Barra>
  );
}
